// extracted by mini-css-extract-plugin
export default {"giftingCoreLayoutContainer":"EKixqK"};